/**
 * user 模块信息
 */

export default {
  namespaced: true,
  state:{
    navList:[
      {
        id:'1',
        title: '首 页',
        path: '/index',
        icon: '',
        type: 1,
      },
      {
        id:'2',
        title: '学 习',
        path: '/study',
        icon: '',
        type: 1,
      },
      {
        id:'3',
        title: '学习社区',
        path: '/exchange',
        icon: '',
        type: 1,
      },
      /*   {
                  id:'4',
                  title: '直播课程',
                  path: '/live',
                  icon: '',
                  type: 1,
               },*/
      /*
				{
				   id:'3',
				   title: '个人中心',
				   path: '/my/index',
				   icon: '',
				   type: 1,
				},*/
      /* {
                  id:'4',
                  title: '外链',
                  path: 'https://www.baidu.com',
                  icon: '',
                  type: 2,
               }*/
    ],
  },
  mutations: {

  },
  actions: {

  },
  getters: {

  }
}
